import { Component, ViewEncapsulation, ViewChild, OnInit, OnDestroy, EventEmitter, forwardRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AnonymousSubscription } from 'rxjs/Subscription';
import { isEmpty } from 'lodash';

import { KeybindService, KEYBOARD_CODES, KeybindDescription } from '~core/services';
import { UserService } from '~auth/services';
import { SignUpComponent } from './signup.component';
import { ModalService } from '~auth/services/modal.service';
import { VerificationComponent } from '~auth/components/verification.component';
import { ForgotPasswordComponent } from '~auth/components/forgot-password.component';
import { UserProfile } from '~auth/model';

@Component({
  selector: 'uw-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignInComponent implements OnDestroy {
  @ViewChild('signIn') signInContent;

  signInModal: NgbModalRef;
  signInForm: FormGroup;
  showError: boolean = false;
  loginFailed: boolean = false;
  signUp: EventEmitter<object> = new EventEmitter();
  progressVisible: boolean;

  close = new EventEmitter();
  subscriptions: AnonymousSubscription[] = [];

  constructor(private ngbModal: NgbModal,
    private fb: FormBuilder,
    private userService: UserService,
    private keybindService: KeybindService,
    private modalService: ModalService) {
    this.signInForm = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, Validators.required]
    });
    this.showError = false;
    this.subscriptions.push(this.keybindService.bind(new KeybindDescription(KEYBOARD_CODES.escape))
      .subscribe(x => this.closeModal('SIGNIN')));
  }

  public logIn() {
    this.progressVisible = true;
    this.loginFailed = false;
    let username = this.signInForm.get('username').value;
    let password = this.signInForm.get('password').value;

    this.userService.signIn(username, password)
      .take(1)
      .subscribe((user: UserProfile) => {
        if (!user || isEmpty(user)) { // UserProfile is Null, Verification is not complete
          this.modalService.getModalComponent(VerificationComponent, { username, pwd: password });
        }
        this.progressVisible = false;
        this.closeModal();
      },
        err => {
          this.loginFailed = true;
          this.progressVisible = false;
        });
  }

  async open(params: any): Promise<any> {
    this.signInForm.reset();
    this.loginFailed = false;
    this.signInModal = this.ngbModal.open(this.signInContent, {
      keyboard: false,
      backdrop: 'static',
      windowClass: 'signin-modal'
    });

    return this.signInModal.result;
  }

  signOut() {
    this.userService.signOut()
      .take(1)
      .subscribe();
  }

  closeModal(reason?: string) {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
    this.close.emit(reason);
    this.signInModal.close(reason);
  }

  openSignUpModal() {
    this.closeModal('SIGNUP');
    this.modalService.getModalComponent(SignUpComponent, '');
  }

  openForgotPassModal() {
    this.closeModal('FORGOT');
    this.modalService.getModalComponent(ForgotPasswordComponent);
  }

  ngOnDestroy() {
    this.close.complete();
    this.signInModal = null;
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/components/signin.component.ts